/**
 * The ID of the global workspace, which is used for flow definitions that are
 * not associated with a workspace, e.g. "marketplace" flows.
 */
export const FLOW_DEFINITION_GLOBAL_WORKSPACE_ID = '*';
